import PropTypes from 'prop-types';
import React from 'react';
import ReactCollapse from 'react-collapse';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { PriceAmounts } from '@sm360/widget-commons-general';

import CurrencyFormats from 'commons-vehicle/constants/currencyFormats.js';
import AmountLineItem from 'commons-vehicle/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.jsx';

class FinanceListing extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showFinanceDetails: true,
        };

        this.showFinanceDetails = this.showFinanceDetails.bind(this);
    }

    showFinanceDetails() {
        this.setState((prevState) => {
            return { showFinanceDetails: !prevState.showFinanceDetails };
        });
    }

    render() {
        const frequency = this.props.paymentFrequencyLabels.periodically;

        const { cashDown, lien, rebates, tradeIn } = this.props.purchaseMethodAmounts;

        const { apr, payment, paymentTaxes, term: termDelay, totalPayment, aprDetails } = this.props.term;
        const finalApr =
            !this.props.displayCreditRate || !aprDetails?.creditRate ? apr : aprDetails?.creditRate.toFixed(2);

        return (
            <div>
                <ul className="SidebarSummary__financialDetails">
                    <div className="SidebarSummary__groupTitle">
                        <h3 className="sr-title SidebarSummary__groupTitle--title">
                            {LocaleService.t('SUMMARY.SUMMARY_FINANCE_TITLE', {
                                finance: this.props.purchaseMethodLabels.name,
                            })}
                        </h3>
                    </div>
                    <ReactCollapse
                        isOpened={this.state.showFinanceDetails}
                        className="SidebarSummary__financialDetails--content"
                    >
                        <li className="SidebarSummary__financialDetails--item vehicle__terms">
                            <span className="label">{LocaleService.t('SUMMARY.TERM')} </span>
                            <span className="value">{termDelay}</span>
                        </li>
                        <li className="SidebarSummary__financialDetails--item vehicle__rate">
                            <span className="label">{LocaleService.t('SUMMARY.APR')} </span>
                            <span className="value important-price">{finalApr}%</span>
                        </li>
                        <li className="SidebarSummary__financialDetails--item vehicle__payments">
                            <span className="label">{LocaleService.t('SUMMARY.PAYMENT')} </span>
                            <span className="value">
                                <PriceAmounts price={LocaleService.l(payment, CurrencyFormats.CURRENCY_2)} />
                            </span>
                        </li>
                        <li className="SidebarSummary__financialDetails--item vehicle__taxes">
                            <span className="label">{LocaleService.t('SUMMARY.TAXES')} </span>
                            <span className="value">
                                <PriceAmounts price={LocaleService.l(paymentTaxes, CurrencyFormats.CURRENCY_2)} />
                            </span>
                        </li>
                    </ReactCollapse>
                    <li className="SidebarSummary__financialDetails--item vehicle__totalPayment">
                        <span className="label">
                            {LocaleService.t('SUMMARY.PAYMENT_WITH_FREQUENCY', { frequency })} <br />
                        </span>
                        <span className="value">
                            <span className="important-price">
                                <PriceAmounts price={LocaleService.l(totalPayment, CurrencyFormats.CURRENCY_2)} />
                            </span>{' '}
                            <br />
                            <span className="sr-text-thin">{LocaleService.t('taxes.taxesIncluded')}</span>
                        </span>
                    </li>
                </ul>
                <ul className="SidebarSummary__listingAmount">
                    <AmountLineItem label={LocaleService.t('SUMMARY.TRADE_IN')} amount={tradeIn} />

                    <AmountLineItem label={LocaleService.t('SUMMARY.LIEN')} amount={lien} />

                    <AmountLineItem label={LocaleService.t('SUMMARY.REBATES')} amount={rebates} />
                    <AmountLineItem label={LocaleService.t('SUMMARY.CASHDOWN')} amount={cashDown} />
                </ul>
            </div>
        );
    }
}

FinanceListing.defaultProps = {
    paymentFrequencyLabels: [],
    purchaseMethodAmounts: [],
    purchaseMethodLabels: [],
    term: [],
    displayCreditRate: false,
};

FinanceListing.propTypes = {
    paymentFrequencyLabels: PropTypes.shape({
        periodically: PropTypes.string.isRequired,
    }),
    purchaseMethodAmounts: PropTypes.shape({
        cashDown: PropTypes.number.isRequired,
        lien: PropTypes.number.isRequired,
        rebates: PropTypes.number.isRequired,
        tradeIn: PropTypes.number.isRequired,
    }),
    purchaseMethodLabels: PropTypes.shape({
        name: PropTypes.string.isRequired,
    }),
    term: PropTypes.shape({
        apr: PropTypes.number.isRequired,
        dueAtDelivery: PropTypes.number.isRequired,
        payment: PropTypes.number.isRequired,
        paymentTaxes: PropTypes.number.isRequired,
        term: PropTypes.number.isRequired,
        totalPayment: PropTypes.number.isRequired,
        amountFinanced: PropTypes.number.isRequired,
    }),
    displayCreditRate: PropTypes.bool,
};

FinanceListing.displayName = 'FinanceListing';

export default FinanceListing;
